// src/constants/Whitelist.js

/**
 * A weboldalhoz hozzáféréssel rendelkező felhasználók egyedi azonosítói (UID).
 * A privát béta fázis alatt csak ők tudnak belépni a weblapon.
 */
export const ALLOWED_UIDS = [
    'S1s8yl02zKRQAj5kGgxbyTnHLBO2', // Egyesület 1
    'zCyBmOiFqRSLq5KHUf12MDxGqgq2', // Egyesület 2
    'c4sTvlqVBwZIQUSbqHA56MOw9wH3', // Versenyző 1
    '1o1A3CmOmJWqxv5TR0INePU70iP2'  // Versenyző 2
];
